import { Colors } from "../colors";
import { Theme } from "./theme";

export const themeDark: Theme = {
  primaryBackgroundColor: Colors.BLACK,
  primaryAccentColor: Colors.ECSTASY,
  primaryTextColor: Colors.ALABASTER,
  primaryFont: "'Open Sans', sans-serif",
  secondaryFont: "'Source Serif Pro', serif",
};
